/**
 * @generated SignedSource<<d6e416f7393bf38eab3ffda1768768fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ids"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "ids",
        "variableName": "ids"
      }
    ],
    "concreteType": "Download",
    "kind": "LinkedField",
    "name": "downloadsByCategory",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updated_at",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DownloadCategory",
        "kind": "LinkedField",
        "name": "main_category",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DownloadsByCategoryQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DownloadsByCategoryQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "a9f463347229bf3db59050a7aca49f5c",
    "id": null,
    "metadata": {},
    "name": "DownloadsByCategoryQuery",
    "operationKind": "query",
    "text": "query DownloadsByCategoryQuery(\n  $ids: [Int!]\n) {\n  downloadsByCategory(ids: $ids) {\n    id\n    name\n    url\n    updated_at\n    main_category {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

node.hash = "92863532f8a37cb793b8d8dd6fb55cbc";

module.exports = node;
